module.exports = __webpack_public_path__ + "media/components/greenroom-articles/static/arrow-right-icon-a13df9ecc81992c8fe50a65cdeeda7e9.svg";